import { Component, AfterViewInit } from '@angular/core';

import { GlobalState } from './global.state';
import { BaThemePreloader, BaThemeSpinner } from './theme/services';
import { config } from '../environments/config';

import 'style-loader!./app.component.scss';
import 'style-loader!./theme/initial.scss';
import { UserIdleService } from './modules/employee/service/user-idle/user-idle.service';
import { LoginService } from './modules/employee/service/login/login.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements AfterViewInit {
  isMenuCollapsed: boolean;
  public testing = config.TESTING;

  constructor(private _state: GlobalState,
              private _spinner: BaThemeSpinner, 
              private userIdleService: UserIdleService, 
              private loginService: LoginService,
              private router: Router) {
    this.isMenuCollapsed = true;
    this._state.subscribe('menu.isCollapsed', (isCollapsed) => {
       this.isMenuCollapsed = isCollapsed;
     });
    window.addEventListener('storage', (event) => {
      if (event.key === 'logoutEvent') {
        this.router.navigate(['/login']);
      }
    });
  }

  ngOnInit() {
    this.userIdleService.idleEvent.subscribe(idle => {
      if (idle) {
        this.loginService.logout();
      }
    });
  }

  public ngAfterViewInit(): void {
    // hide spinner once all loaders are completed
    BaThemePreloader.load().then((values) => {
      this._spinner.hide();
    });
  }

  public spinnerShow() {
    this._spinner.show();
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/app.component.ts